import { cmsErrorText } from './sections/admin-cms';

export function note(id: string): string {
  return `<span id="${id}" role="status" class="text-[13px] text-muted ml-3"></span>`;
}

export type ScopedQuery = <T extends HTMLElement>(sel: string) => T | null;

export function scopedHelpers(container: HTMLElement) {
  const $ = <T extends HTMLElement>(sel: string) => container.querySelector<T>(sel);
  const read = (id: string) => $<HTMLInputElement>(`#${CSS.escape(id)}`)?.value ?? '';

  function say(id: string, text: string, bad = false): void {
    const el = $<HTMLElement>(`#${id}`);
    if (!el) return;
    el.textContent = text;
    el.classList.toggle('text-red-400', bad);
    el.classList.toggle('text-muted', !bad);
  }

  async function run(btn: HTMLButtonElement | null, msgId: string, work: () => Promise<string>): Promise<void> {
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    say(msgId, '');
    try {
      const text = await work();
      say(msgId, text);
    } catch (err) {
      say(msgId, cmsErrorText(err), true);
    } finally {
      if (btn.isConnected) btn.disabled = false;
    }
  }

  return { $, read, say, run };
}
